export const text = {
  cellNotEditable: '-',
  cellNotSet: 'Not set',
} as const;

export const aggregationRow = 'aggregation-row';
export const totalCountAggregationColumnField = 'meta.schema_queues';
